import curry from './curry'
import mergeDeepWithKey from './mergeDeepWithKey'

/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 *
 *  - if both values are objects, the two values will be recursively merged
 *  - otherwise the value from the first object with be used
 *
 * const merged = mergeDeepLeft(
 *   { name: 'test', age: 20, contact: { email: 'test@gmail.com' } },
 *   { age: 45, contact: { email: 'another@test.com' } }
 * )
 * merged -> { name: 'test', age: 10, contact: { email: 'test@gmail.com' } }
 */

const mergeDeepLeft = curry((obj1, obj2) => {
	return mergeDeepWithKey((key, obj1Val, obj2Val) => {
		return obj1Val
	}, obj1, obj2)
})
export default mergeDeepLeft
